<template>
	<div class="moModuleFilter" @keyup.enter="doEnterThings()">
		<card class="majorFilter-card">
			<!--<div class="filter-row" v-if="$GVO.my_profile.is_boss!==0"> -->
			<div class="filter-row">
				<div class="mr-3 flat-corp-width"> 
					<h5 class="col-form-label mr-3 pb-0">Объекты</h5>
					<ReSearchStaffClients 
						placeholder="ФИО сотрудника"
						placeholder_otdel="Название отдела"
						v-model="objFilterData.structure.value"
						:objApiMethod="{'obj':'staff','flt':{'fio':''}}"
						:strApiMethodKey="'fio'"
						:objApiMethod_otdel="{'obj':'structures','flt':{'name':''}}"
						:strApiMethodKey_otdel="'name'"
						:rb_options="objFilterData.structure.rb_options"
						v-on:change="OnAjaxListSearch"
						
					/>
				</div>				
			</div>
			<div class="filter-row mb-1">
				<h5 class="col-form-label mr-3 pb-0">Статус модерации</h5>
				<base-radio v-for="(el_opt, el_index) in objFilterData.moderation_status.options" 
				:name="el_opt.value" 
				:label="el_opt.label" 
				:key="el_index"
				v-model="objFilterData.moderation_status.value" 
				inline>{{el_opt.label}}</base-radio>
			</div>
			<div class="filter-row mb-1">
				<h5 class="col-form-label mr-3 pb-0">Статус ошибок площадок</h5>
				<base-checkbox v-model="objFilterData.adserrors.value" inline>С ошибками</base-checkbox>
			</div>
				
			<div class="filter-row mb-2">
				<h5 class="col-form-label mr-3 pb-0">Статус услуги</h5>
				<base-checkbox v-model="objFilterData.srv_oncontrol.value" inline>На контроле</base-checkbox>
				<base-checkbox v-model="objFilterData.srv_new.value" inline>Новые</base-checkbox>
				<base-checkbox v-model="objFilterData.srv_inwork.value" inline>В работе</base-checkbox>
				<base-checkbox v-model="objFilterData.srv_sdelka.value" inline>Сделка</base-checkbox>
				<base-checkbox v-model="objFilterData.srv_arhiv.value" inline>Архив</base-checkbox>
			</div>
			<div class="majorFilter row px-3">
				<div class="firstFilter-row"> 
	
					<div class="mb-2 px-0 mr-3">
						<el-select
								class="w-100 px-0 select-primary mb-3"
								v-model="objFilterData.dealType.value" 
								placeholder="Тип сделки"
								size="large"
								clearable
							>
							<el-option
								class="select-primary"
								v-for="item in objFilterData.dealType.options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					<div class="mb-2 px-0 mr-3">
						<el-select
								class="w-100 px-0 select-primary mb-3"
								v-model="objFilterData.objectType.value" 
								placeholder="Тип объекта"
								size="large"
								clearable
							>
							<el-option
								class="select-primary"
								v-for="item in objFilterData.objectType.options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					<div class="base-search col col-xl-2 px-0 mr-3">
						<base-input
							placeholder="Количество комнат(только для кв)"							
							v-model="objFilterData.roomsCountTotal.value"
							autocomplete="off"
							type="number"
						>
						</base-input>
					</div>
					<div class="price-search mr-3 mb-2">
						<ReInputRange class="mb-3" v-model="objFilterData.price.value" placeholder="Цена от|до" inputType="money"/>
					</div>
					<div class="base-search col-md-3 px-0 mr-3">
						<base-input
							placeholder="Поиск по городу, адресу, метро, району, ж/д, шоссе, ЖК"
							addon-left-icon="tim-icons icon-zoom-split"
							v-model="objFilterData.addr.value"
							autocomplete="off"
						>
						</base-input>
					</div>
					<div class="base-search id-search col-md-2 px-0 mr-3">
						<base-input
							placeholder="Поиск ID"
							addon-left-icon="tim-icons icon-zoom-split" 
							v-model="objFilterData.id.value" 
							autocomplete="off"
						>
						</base-input>
					</div>
					<div class="base-search col-md-2 px-0 mr-3">
						<base-input
							placeholder="Поиск по описанию"
							addon-left-icon="tim-icons icon-zoom-split" 
							v-model="objFilterData.description.value" 
							autocomplete="off"
						>
						</base-input>
					</div>
					<div class="base-search col-md-2 px-0 mr-3">
						<base-input
							placeholder="Поиск по договору"
							addon-left-icon="tim-icons icon-zoom-split" 
							v-model="objFilterData.agrm_number.value" 
							autocomplete="off"
						>
						</base-input>
					</div>
					

					<div class="allFilters">
						<base-button @click="ShowFilter()" type="primary" simple ><i class="d-inline-block tim-ic ic-filter mr-2"></i><span>Все фильтры</span><span class="badge badge-pill badge-primary ml-2" v-if="optCount != ''">{{optCount}}</span></base-button>
					</div>
					<div class="applyFilter">
						<base-button @click="OnFilterApply()" type="success">Применить</base-button>
					</div>

				</div>
				
				<div class="firstFilter-row filter-tags mt-2">
					<el-tag
						v-for="tag in filterTags"
						:key="tag.param_id"
						size="small"
						:closable="true"
						:close-transition="false"
						@close="handleClose(tag)"
						:type="'primary'"
					>
					{{ tag.name }}
					</el-tag>
					<span v-if="optCount != ''" class="el-tag el-tag--danger el-tag--small el-tag--light"> Сбросить всё <i class="el-tag__close el-icon-close" @click="OnFilterReset()"></i></span>
				</div>

			</div>

			<hr v-show="this.bShowFilter">

			<div class="moreFilter mt-3" v-show="bShowFilter">
				<div class="filter-row">
					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width"> 
							<h5 class="col-form-label col-md-12"> Площадь общая</h5>
							<ReInputRange class="mb-2" v-model="objFilterData.square.value" placeholder="от|до" inputType="number"/>
							<h5 class="col-form-label col-md-12">Площадь кухни</h5>
							<ReInputRange class="mb-3" v-model="objFilterData.kitchenSquare.value" placeholder="от|до" inputType="number"/>
						</div>

						<div class="mr-3 mb-2 flat-corp-width"> 
							<h5 class="col-form-label col-md-12">Этаж</h5>
							<ReInputRange  v-model="objFilterData.floor.value" placeholder="от|до" inputType="number"/>
							<base-checkbox v-model="objFilterData.dfloorlast.value" inline>Последний</base-checkbox>
							<base-checkbox v-model="objFilterData.dfloornotfst.value" inline>Кроме первого</base-checkbox>
							<base-checkbox v-model="objFilterData.dfloornotlst.value" inline>Кроме последнего</base-checkbox>
						</div>
					</div>

					
					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width">
							<h5 class="col-form-label col-md-12">Санузел</h5>
							<div class="d-flex">
							<el-select
								class="w-100 px-0 select-primary mb-3"
								v-model="objFilterData.toilet.value" 
								placeholder="Санузел"
								size="large"
								clearable
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.toilet.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.toilet.value = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
							</div>
							<h5 class="col-form-label col-md-12">Ремонт</h5>
							<div class="d-flex">
							<el-select
								class="overflow-overlay col-md px-0 select-primary mb-3 "
								v-model="objFilterData.renovation.value" 
								placeholder="Ремонт"
								size="large"
								:multiple="true"								
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.renovation.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.renovation.value = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
							</div>
							<h5 class="col-form-label col-md-12">Балкон</h5>
							<div class="d-flex">
							<el-select
								class="w-100 px-0 select-primary mb-3"
								v-model="objFilterData.balcony.value" 
								placeholder="Балкон"
								size="large"
								clearable
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.balcony.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.balcony.value = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
							</div>
						</div>

						
						
					</div>

					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width">
							<h5 class="col-form-label col-md-12">Дата сдачи (только для новостроек)</h5>
							<el-select						
								class="col-md px-0 select-primary overflow-overlay"						
								filterable
								placeholder="Квартал"
								multiple						
								size="large"
								v-model="objFilterData.readyDateQuarter.value" 
							>
								<el-option
									class="select-primary long-select"
									v-for="option in objFilterData.readyDateQuarter.options"
									:key="option.label"
									:label="option.label"
									:value="option.value"
								>
								</el-option>
							</el-select>
							<el-select						
								class="col-md px-0 select-primary overflow-overlay"						
								filterable
								placeholder="Год"
								multiple						
								size="large"
								v-model="objFilterData.readyDateYear.value" 
							>
								<el-option
									class="select-primary long-select"
									v-for="option in objFilterData.readyDateYear.options"
									:key="option.label"
									:label="option.label"
									:value="option.value"
								>
								</el-option>
							</el-select>
							<h5 class="col-form-label col-md-12">Дата публикации</h5>
							<el-select
								class="overflow-overlay col-md px-0 select-primary mb-3 "
								v-model="objFilterData.creationDate.value" 
								placeholder="Дата публикации"
								size="large"
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.creationDate.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>

							<div class="filter-row mb-1">
								<h5 class="col-form-label mr-3 pb-0">Выгрузка в рекламу</h5>
								<base-radio v-for="(el_opt, el_index) in objFilterData.actual.options" 
								:name="el_opt.value" 
								:label="el_opt.label" 
								:key="el_index"
								v-model="objFilterData.actual.value" 
								inline>{{el_opt.label}}</base-radio>
							</div>
							<div class="filter-row mb-1">
								<h5 class="col-form-label mr-3 pb-0">Реальность объекта</h5>
								<base-radio v-for="(el_opt, el_index) in objFilterData.promo.options" 
								:name="el_opt.value" 
								:label="el_opt.label" 
								:key="el_index"
								v-model="objFilterData.promo.value" 
								inline>{{el_opt.label}}</base-radio>
							</div>
							<div class="filter-row mb-1">
								<h5 class="col-form-label mr-3 pb-0">Договор / Согласие</h5>
								<base-radio v-for="(el_opt, el_index) in objFilterData.agrm.options" 
								:name="el_opt.value" 
								:label="el_opt.label" 
								:key="el_index"
								v-model="objFilterData.agrm.value" 
								inline>{{el_opt.label}}</base-radio>
							</div>
							<!-- <div class="mr-3 mb-2 flat-corp-width"> 
								<base-checkbox v-model="objFilterData.promo.value" inline>Промо-объект</base-checkbox>
							</div> -->
						</div>
						
					</div>	


					<div class="col-md-4 col-sm-6 pl-0">
						<!-- div class="mr-3 mb-2 flat-corp-width">
							<h5 class="col-form-label col-md-12">До метро</h5>
							<el-select
								class="overflow-overlay col-md px-0 select-primary mb-1 "
								v-model="objFilterData.distanceType.value" 
								placeholder="Тип расстояния"
								size="large"
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.distanceType.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-input
								placeholder="км"
								v-model="objFilterData.distanceToMetro.value"
								type="number"
								autocomplete="off"
							></base-input>
						</div-->
						
						

						<div class="mr-3 mb-2 flat-corp-width"> 
							<base-checkbox v-model="objFilterData.mortgage.value" inline>Ипотека</base-checkbox>
							<base-checkbox v-model="objFilterData.credit.value" inline>Рассрочка</base-checkbox>
							<base-checkbox v-model="objFilterData.reassignment.value" inline>Переуступка</base-checkbox>
							<base-checkbox v-model="objFilterData.apartments.value" inline>Апартаменты</base-checkbox>
						</div>
					</div>

				</div>
			</div>
		</card>
		<!-- <div class="mb-4">
			<div class="row justify-content-end mx-0">
				<el-select						
					class="col-md col-xl-4 px-0 select-primary  overflow-overlay"
					placeholder="Сортировка по умолчанию"
					size="large"
					v-model="objFilterData.dSortType.value"
					@change="OnFilterApply()"
				>
					<el-option
						class="select-primary long-select"
						v-for="option in objFilterData.dSortType.options"
						:key="option.label"
						:label="option.label"
						:value="option.value"
					>
					</el-option>
				</el-select>
			</div>
		</div> -->
	</div>
</template>
<script>

import { Select, Option } from 'element-ui';
import { BaseCheckbox, BaseRadio, /*BaseSwitch,*/ } from 'src/components/index';
// import ReFromMetro from "src/our_components/ReFromMetro.vue";
import ReInputRange from "src/our_components/ReInputRange.vue";
// import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
import ReSearchStaffClients from 'src/our_components/ReSearchStaffClients.vue';

import { Tag } from 'element-ui';
// import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
// import ReSelectCascadeObjCategory from 'src/our_components/ReSelectCascadeObjCategory.vue';

export default {
	name: 'moModuleFilter',
	components: {
		[Option.name]: Option,
		[Select.name]: Select,
		BaseCheckbox,
		BaseRadio,
		// BaseSwitch,
		// ReFromMetro,
		ReInputRange,
		[Tag.name]: Tag,
		// ReInputSearchDrop,
		// ReInputSearchDropType,
		// ReSelectCascadeObjCategory,
		ReSearchStaffClients,
	},
	props: {
		value: String,
		
	},
	data() {
		return {
			bShowFilter: false,
			BigSearch: {inputText: '', selectedVal:''}, //поиск по городу и прочему. Вопрос про формат данных и их соответсвие с базой
			objGetParams: {},
			masExcludeParams: ['page','p','c2p','AddComplexMinFlatsBig','dSortOrder','dSortType','dSearchType','client_id','taskend_id','task_id','service_id'],
			optCount: '',
			filterTags:[],
			objFilterData: { //Правила: 1) Имя свойсва - это параметр отправляем в GET метод АПИ; 2) одно свойство - одно поле/компонет. 3) В свойстве поле value привязывать к v-model поля/компонета. 4) Все поля/компонета должны уметь v-model
				structure: {
					value: {'agent_id':'','otdel_id':'','isFired':''}, 
					tagText:'Объекты', 
					elementType: 'ajax-list-client', 
					rb_options: [{'name': '0', 'label': 'Все объекты'},{'name': '1', 'label': 'Мои объекты'}], 
					value_default: {'agent_id':'','otdel_id':'','isFired':''},
					catalog:'CAT_STAFF'
				}, //'elementGetParamMap'=>'agent_id|otdel_id|isFired',
				roomsCountTotal:{value:'', elementType: 'input', value_default: '', tagText:'Комнат'},
				objectType:{value:'', catalog:'ObjectType',options:[], tagText:'Тип объекта', elementType: 'select', value_default: ''},
				dealType:{value:'', catalog:'DealType', options:[], tagText:'Тип сделки', elementType: 'select', value_default: ''},
				// salesTypeId:{value:'', catalog:'', options:[{value: '3',label: 'Собственник',},{value: '2',label: 'Агент'},{value: '1',label: 'Частное лицо'}], tagText:'Тип клиента', elementType: 'select', value_default: ''},
				// sourceId:{value:'', catalog:'cat_objects_source', options:[], tagText:'Источник объявления', elementType: 'select', value_default: ''},
				// cellId:{value:'', catalog:'', options:[{value: '0',label: 'ID1 Название Соты 1',},{value: '1',label: 'ID2 Название Соты 2'},{value: '2',label: 'ID3 Название Соты 3'}], tagText:'Ячейка', elementType: 'select', value_default: ''},
				id:{value:'', tagText:'ID', elementType: 'input', value_default: ''},
				description:{value:'', tagText:'Описание', elementType: 'input', value_default: ''},
				agrm_number:{value:'', tagText:'Договор', elementType: 'input', value_default: ''},
				addr:{value:'', tagText:'Адрес', elementType: 'input', value_default: ''},
			//readyDateQuarter вопрос: в каком формате слать данные?
				readyDateQuarter:{value:'', catalog:'Quarter', options:[], tagText:'Квартал', elementType: 'select', value_default: ''},
				readyDateYear:{value:'', catalog:'', options:[{value: '2022',label: '2022',},{value: '2023',label: '2023'},{value: '2024',label: '2024'},{value: '2025',label: '2025'}], tagText:'Год сдачи', elementType: 'select', value_default: ''},
				distanceToMetro:{value:'', tagText:'км', elementType: 'input', value_default: ''},
				distanceType:{value:'', catalog:'DistanceType', options:[], tagText:'Тип расстояния', elementType: 'select', value_default: ''},
				creationDate:{value:'', catalog:'', options:[
					{value: '0',label: 'Неважно',},
					{value: '1',label: 'За месяц',},
					{value: '2',label: 'За неделю',},
					{value: '3',label: 'За сегодня',},
					{value: '4',label: 'За час',},
				], tagText:'Дата публикации', elementType: 'select', value_default: ''},
				balcony:{value:'', catalog:'Balcony', options:[], tagText:'Балкон', elementType: 'select', value_default: ''},
				renovation:{value:'', catalog:'Renovation', options:[], tagText:'Ремонт', elementType: 'select', value_default: ''},
				toilet:{value:'', catalog:'Toilet', options:[], tagText:'Санузел', elementType: 'select', value_default: ''},

				price:{value:{min:'',max:''}, map_min:'pricemin', map_max:'pricemax', tagText:'Стоимость', elementType: 'input-range', value_default: {min:'',max:''}},
				square:{value:{min:'',max:''}, map_min:'squaremin', map_max:'squaremax', tagText:'Площадь общая', elementType: 'input-range', value_default: {min:'',max:''}},
				kitchenSquare:{value:{min:'',max:''}, map_min:'kitchenSquaremin', map_max:'kitchenSquaremax', tagText:'Площадь кухни', elementType: 'input-range', value_default: {min:'',max:''}},
				floor:{value:{min:'',max:''}, map_min:'dfloorfrom', map_max:'dfloorto', tagText:'Этаж', elementType: 'input-range', value_default: {min:'',max:''}},
				dfloorlast:{value:false, tagText:'Этаж последний', elementType: 'checkbox', value_default: false},
				dfloornotfst:{value:false, tagText:'Кроме первого', elementType: 'checkbox', value_default: false},
				dfloornotlst:{value:false, tagText:'Кроме последнего', elementType: 'checkbox', value_default: false},

				srv_oncontrol:{value:false, tagText:'На контроле', elementType: 'checkbox', value_default: false},
				srv_new:{value:false, tagText:'Новые', elementType: 'checkbox', value_default: true},
				srv_inwork:{value:false, tagText:'В работе', elementType: 'checkbox', value_default: true},
				srv_sdelka:{value:false, tagText:'Сделка', elementType: 'checkbox', value_default: false},
				srv_arhiv:{value:false, tagText:'Архив', elementType: 'checkbox', value_default: false},

				adserrors:{value:false, tagText:'С ошибками', elementType: 'checkbox', value_default: false},

				mortgage:{value:false, tagText:'Ипотека', elementType: 'checkbox', value_default: false},
				credit:{value:false, tagText:'Рассрочка', elementType: 'checkbox', value_default: false},
				apartments:{value:false, tagText:'Апартаменты', elementType: 'checkbox', value_default: false},
				reassignment:{value:false, tagText:'Переуступка', elementType: 'checkbox', value_default: false},
				// promo:{value:false, tagText:'Промо', elementType: 'checkbox', value_default: false},
				
				moderation_status: {value:'', elementType: 'MStatusRadio', value_default: '', options:[
					{value: 0, label: 'Любая модерация'}, 
					{value: 1, label: 'Не проверенные'},
					{value: 2, label: 'Принятые'},
					{value: 3, label: 'Отклоненные'},
				], tagText:'Статус модерации'},
				actual: {value:'', elementType: 'radio', value_default: 0, options:[
					{value: 0, label: 'Любая'}, 
					{value: 1, label: 'Актуально'},
					{value: 2, label: 'Снято'},
				], tagText:'Выгрузка в рекламу'},
				promo: {value:'', elementType: 'radio', value_default: 0, options:[
					{value: 0, label: 'Любая'}, 
					{value: 1, label: 'Промо'},
					{value: 2, label: 'Реальный'},
				], tagText:'Реальность объекта'},
				agrm: {value:'', elementType: 'radio', value_default: 0, options:[
					{value: 0, label: 'Все объекты'}, 
					{value: 1, label: 'Договор'},
					{value: 2, label: 'Согласие'},
					{value: 3, label: 'Нет ничего'},
				], tagText:'Документы'},
				
				// rb_options:{value:false, tagText:'Архив', elementType: 'checkbox', value_default: false},

				dSearchType:{value:'', elementType: 'input-hidden', value_default: ''}, // flats||flatmap
				// dSortType:{value:'dt_upde|d', catalog:'', options:[
				// 	{value: 'dt_upd|d',label: 'По дате обновления (сначала новые)',},
				// 	{value: 'dt_upd|a',label: 'По дате обновления (сначала старые)',},
				// 	{value: 'dt_cre|d',label: 'По дате создания (сначала новые)',},
				// 	{value: 'dt_cre|a',label: 'По дате создания (сначала старые)',},
				// 	{value: 'price|a',label: 'По цене (сначала дешевле)',},
				// 	{value: 'price|d',label: 'По цене (сначала дороже)',},
				// ], tagText:'Сортировка', elementType: 'select', value_default: ''},
								
			},
		};
	},
	computed: {
		
		dmaxprice(){
			return this.objFilterData.price.value.max;
		},
		dminprice(){
			return this.objFilterData.price.value.min;
		},
		bInObjectPage(){
			if(location.pathname.indexOf('/sso/objectscnd/') != -1) return true;
			return false;
		},
	},
	watch: {
		// dmaxprice(val){
		// 	val = this.$GVO.str_replace(' ','',val);
		// 	let number1 = this.$GVO.number_format(val,0,'.',' ');
		// 	if(number1 == 0 ){ number1= ''; }
		// 	this.objFilterData.price.value.max = number1;
		// },
		// dminprice(val){
		// 	val = this.$GVO.str_replace(' ','',val);
		// 	let number1 = this.$GVO.number_format(val,0,'.',' ');
		// 	if(number1 == 0 ){ number1= ''; }
		// 	this.objFilterData.price.value.min = number1;
		// },		
	},
	methods: {
		findTag(tag){
			for (let i = 0; i < this.filterTags.length; i++) {
				const elTag = this.filterTags[i];
				if(/*elTag.name == tag.name && */elTag.param_id == tag.param_id) return i;
			}
			return -1;
		},
		translateTags(data){
			let strValue = '';
			let masValue = [];
			if(data.selectedType == 'ajax-list-client'){
				data.selectedType = 'structure';
				if(this.objFilterData[data.selectedType].value.agent_id != ''){
					masValue.push(this.objFilterData[data.selectedType].value.agent_id);
				}
				if(this.objFilterData[data.selectedType].value.otdel_id != ''){
					masValue.push(this.objFilterData[data.selectedType].value.otdel_id);
					// console.log('translateTags', this.objFilterData[data.selectedType].value.otdel_id);
				}
				if(this.objFilterData[data.selectedType].value.isFired != ''){
					masValue.push(this.objFilterData[data.selectedType].value.isFired);
				}
			}else{
				strValue = this.objFilterData[data.selectedType].value;
				masValue = strValue.split(';');
			}
			for (let i = 0; i < masValue.length; i++) {
				masValue[i] = this.$GVO.GetCat(this.objFilterData[data.selectedType].catalog,masValue[i]).name;
				//для this.objFilterData['structure'] придумать что-то с каталогом для имён сотрудников и отделов
			}
			strValue = masValue.join(';');
			return strValue;
		},
		OnBigSearch(data){
			let masTmp = [];
			if(typeof this.objFilterData[data.selectedType] != 'undefined'){
				let strValue = this.translateTags(data);

				let tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				if(this.findTag(tag) != -1) this.filterTags.splice(this.findTag(tag), 1); // закрываем старый тег

				if(this.objFilterData[data.selectedType].value != ''){
					masTmp = this.objFilterData[data.selectedType].value.split(';');
				}
				masTmp.push(data.selectedVal);
				this.objFilterData[data.selectedType].value = masTmp.join(';');

				this.BigSearch.inputText='';
				strValue = this.translateTags(data);

				tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				this.filterTags.push(tag);
			}
		},
		handleClose(tag,bApply=true) { // переделать всё на this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default)
			if(this.objFilterData[tag.param_id].elementType == 'input-range'){
				this.objFilterData[tag.param_id].value.min = '';
				this.objFilterData[tag.param_id].value.max = '';
			} else if(this.objFilterData[tag.param_id].elementType == 'checkbox'){
				this.objFilterData[tag.param_id].value = false;
			} else if(this.objFilterData[tag.param_id].elementType == 'radio'){
				this.objFilterData[tag.param_id].value = 0;
			} else if(this.objFilterData[tag.param_id].elementType == 'distanceToMetro'){
				this.objFilterData[tag.param_id].value = this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default);
			} else if(this.objFilterData[tag.param_id].elementType == 'ajax-list-client'){
				this.objFilterData[tag.param_id].value = this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default);
			} else {
				this.objFilterData[tag.param_id].value = '';
			}
			this.filterTags.splice(this.findTag(tag), 1);
			if(bApply) this.OnFilterApply();
		},
		setOptCount(data=false){ // тут не только считается количество параметров в фильтре. НО и отрисовка тегов
			if(!data){
				this.objGetParams = this.$GVO.GetAllGet();
			}else{
				this.objGetParams = data; 
			}
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				let masKeys = Object.keys(this.objGetParams);
				//console.log('setOptCount_masKeys',masKeys);
				let iOptsCount = 0;
				this.filterTags = [];
				if(typeof this.masExcl != 'undefined'){
					this.masExcludeParams = [...this.masExcludeParams, ...this.masExcl];
				}
				for (let i = 0; i < masKeys.length; i++) {
					if(this.masExcludeParams.indexOf(masKeys[i]) === -1){									
						if(this.objGetParams[masKeys[i]] !== false && this.objGetParams[masKeys[i]] !== 'false'){
							//console.log('setOptCount_masKeys_i',masKeys[i]);
							let element = this.getFilterDataElement(masKeys[i]);
							if(typeof element === 'undefined') continue;
							//console.log('setOptCount_element',element);
							let bInTags = false;
							for (let iTag = 0; iTag < this.filterTags.length; iTag++) {
								if(this.filterTags[iTag].param_id == element.param_id){
									bInTags = true;
								}
							}
							if(!bInTags){
								iOptsCount++;
								let tag = {name: `${element.tagText}: ${element.value}`, param_id: element.param_id};
								if(element.elementType == 'input-range'){
									let strText = '';
									if(!this.$GVO.isEmpty(element.value.min)){
										strText += 'от '+element.value.min;
									}
									if(!this.$GVO.isEmpty(element.value.max)){
										strText += ' до '+element.value.max;
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'checkbox'){
									if(element.value == true){
										tag = {name: element.tagText, param_id: element.param_id};
									}else{
										tag = null;
									}
								}
								else if(element.elementType == 'radio'){
									let strText = '';
									for (let iRadio = 0; iRadio < element.options.length; iRadio++) {
										if(element.options[iRadio].value == element.value) {
											strText = element.options[iRadio].label;
										}
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} 
								else if(element.elementType == 'select'){
									let strText = '';
									for (let iSel = 0; iSel < element.options.length; iSel++) {
										//if(element.options[iSel].value == element.value) strText = element.options[iSel].label;
										if(element.value.indexOf(element.options[iSel].value) != -1) strText += element.options[iSel].label+';';
									}
									tag = {name: `${element.tagText}: ${strText.slice(0, -1)}`, param_id: element.param_id};
								} else if(element.elementType == 'input-hidden-mdgd'){
									let strText = this.translateTags({selectedType: element.param_id});
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'distanceToMetro'){
									let strText = '';
									if(element.value.dWayTypeFromMetro == '0'){
										strText = 'пешком';
									}else{
										strText = 'на транспорте';
									}
									tag = {name: `${element.tagText}: ${strText} ${element.value.dTimeFromMetro} мин`, param_id: element.param_id};
								} else if(element.elementType == 'ajax-list-client'){
									let strText = '';
									if(element.value.agent_id != ''){
										strText = 'агент ';
										strText += this.translateTags({selectedType: element.elementType});
									}
									if(element.value.otdel_id != ''){
										//console.log(element.value.otdel_id);
										var masRetTree = [];
										/* Ищет рекурсивно по массиву, параетры 1-дерево для поиска, 2-название своства в узле дерева, 3-его значение, 4-куда отдать результат */
										this.$GVO.SeachTreeReq(this.$GVO.masTreeOrgStruct,'id',element.value.otdel_id,masRetTree);
										//console.log(masRetTree);
										strText = typeof masRetTree[0].name!='undefined'?masRetTree[0].name:'отдел '+element.value.otdel_id;

									}
									if(element.value.isFired != ''){
										strText += ' с уволенными';
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'MStatusRadio'){
									// сделано только для группы радиобатонов Статуса модерации
									let strText = '';
									for (let iMStatus = 0; iMStatus < this.objFilterData.moderation_status.options.length; iMStatus++) {
										if(this.objFilterData.moderation_status.options[iMStatus].value == element.value) {
											strText = this.objFilterData.moderation_status.options[iMStatus].label;
										}
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								}
								if(tag != null ) this.filterTags.push(tag);
							}						
						}
					}
				}
				this.optCount = iOptsCount;
			} else {
				this.optCount = '';
				this.filterTags = [];
			}
		},
		getFilterDataElement(strKey){
			if (this.objFilterData.hasOwnProperty(strKey)){
				this.objFilterData[strKey].param_id = strKey;
				return this.objFilterData[strKey];
			} else if(	strKey == 'dfloorfrom' || 
						strKey == 'dfloorto' || 
						strKey == 'squaremin' || 
						strKey == 'squaremax' || 
						strKey == 'kitchenSquaremin' || 
						strKey == 'kitchenSquaremax' || 
						strKey == 'pricemin' || 
						strKey == 'pricemax'){ // установка параметров в компонент "отдо" ReInputRange
				for (const keyInFlt in this.objFilterData) {
					if (this.objFilterData.hasOwnProperty(keyInFlt) && this.objFilterData[keyInFlt].elementType=='input-range') {
						if ( (typeof this.objFilterData[keyInFlt].map_min != 'undefined' && this.objFilterData[keyInFlt].map_min == strKey) || (typeof this.objFilterData[keyInFlt].map_max != 'undefined' && this.objFilterData[keyInFlt].map_max == strKey) ) {
							this.objFilterData[keyInFlt].param_id = Object.keys(this.objFilterData).find(key => this.objFilterData[key] === this.objFilterData[keyInFlt]);
							return this.objFilterData[keyInFlt];
						}
					}
				}
			} else if(strKey == 'dWayTypeFromMetro' || strKey == 'dTimeFromMetro'){
				this.objFilterData['distanceToMetro'].param_id = 'distanceToMetro';
				return this.objFilterData['distanceToMetro'];
			} else if(strKey == 'agent_id' || strKey == 'otdel_id' || strKey == 'isFired'){
				this.objFilterData['structure'].param_id = 'structure';
				return this.objFilterData['structure'];
			}
		},
		ShowFilter(){
			this.bShowFilter = !this.bShowFilter;
		},
		SetFilterParams(){ // загружает значения в фильтр из ГЕТ строки
			//return true;
			//console.log('SetFilterParams',this.$GVO.unlinkObject(this.objGetParams));
			for (const key in this.objGetParams) {
				if (this.objGetParams.hasOwnProperty(key)) {
					let element = this.getFilterDataElement(key);
					// console.log(key,element);
					if (this.objFilterData.hasOwnProperty(key)) {
						if(this.objGetParams[key] != '' && this.objGetParams[key] != '[object Object]'){
							if(key == 'ddecoration' || key == 'dbanks'){
								this.objFilterData[key].value = this.objGetParams[key].split(';');
							} else {
								if(element.elementType == 'input-hidden-mdgd'){
									this.objFilterData[key].value = this.objGetParams[key];
								}else {
									if (typeof this.objFilterData[key].value == 'boolean') {
										this.objFilterData[key].value = parseInt(this.objGetParams[key])==0?false:true;
										// console.log(key,element);
									} else {
										this.objFilterData[key].value = this.objGetParams[key];
										
									}
								}
							}
						}
					} else if(typeof element !='undefined' && element.elementType == 'input-range'){
						for (const keyInFlt in this.objFilterData) {
							if (this.objFilterData.hasOwnProperty(keyInFlt)) {
								if (typeof this.objFilterData[keyInFlt].map_min != 'undefined' && this.objFilterData[keyInFlt].map_min == key) {
									this.objFilterData[keyInFlt].value.min = this.objGetParams[key];
								}
								if (typeof this.objFilterData[keyInFlt].map_max != 'undefined' && this.objFilterData[keyInFlt].map_max == key) {
									this.objFilterData[keyInFlt].value.max = this.objGetParams[key];
									
								}
							}
						}
					} else if(key == 'dWayTypeFromMetro' || key == 'dTimeFromMetro'){
						this.objFilterData['distanceToMetro'].value[key] = this.objGetParams[key];
					} else if(key == 'agent_id' || key == 'otdel_id' || key == 'isFired'){
						//console.log('structure '+key);
						this.objFilterData['structure'].value[key] = this.objGetParams[key];
					} else if(key == 'srv_new'){
						//console.log('structure '+key);
						this.objFilterData['srv_new'].value[key] = this.objGetParams[key];
					} 
					// else if(typeof element !='undefined' && element.elementType == 'radio'){
					// 	//console.log('structure '+key);
					// 	this.objFilterData[key].value = this.objGetParams[key];
					// }
				}
			}
			//console.log('SetFilterParams==',this.$GVO.unlinkObject(this.objGetParams));
			this.OnFilterApply();
		},
		ApplyFilterParams(){ // подготавливает значения из фильтра для ГЕТ строки
			//console.log('ApplyFilterParams');
			//return true;
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key)) {
					let element = this.getFilterDataElement(key);
					if(element.elementType == 'input-range'){
						if(typeof this.objFilterData[key].map_min != 'undefined' && this.objFilterData[key].map_min != ''){
							if(!this.$GVO.isEmpty(this.objFilterData[key].value.min)){
								this.objGetParams[this.objFilterData[key].map_min] = this.$GVO.str_replace(' ','',this.objFilterData[key].value.min);
							}
						}
						if(typeof this.objFilterData[key].map_max != 'undefined' && this.objFilterData[key].map_max != ''){
							if(!this.$GVO.isEmpty(this.objFilterData[key].value.max)){
								this.objGetParams[this.objFilterData[key].map_max] = this.$GVO.str_replace(' ','',this.objFilterData[key].value.max);
							}
						}

						if(this.$GVO.isEmpty(element.value.min)) delete this.objGetParams[element.map_min];
						if(this.$GVO.isEmpty(element.value.max)) delete this.objGetParams[element.map_max];
					}else if(element.elementType == 'checkbox'){
						if(element.value === true){
							this.objGetParams[key] = this.objFilterData[key].value===true?1:0; //console.log('this.objFilterData[key] ',this.objFilterData[key]);
							
						}else{
							if(key != 'dnotworkgk'){
								delete this.objGetParams[key];
							}else{
								this.objGetParams[key] = this.objFilterData[key].value===true?1:0;
							}
						}
					}else if((key == 'ddecoration' || key == 'dbanks') && this.objFilterData[key].value.length > 0){
						this.objGetParams[key] = this.objFilterData[key].value.join(';');
					}else if(element.elementType == 'fromSubway'){
						if(typeof this.objFilterData[key].value.dTimeFromMetro != 'undefined' && this.objFilterData[key].value.dTimeFromMetro != ''){
							this.objGetParams['dTimeFromMetro'] = this.objFilterData[key].value.dTimeFromMetro;
							if(typeof this.objFilterData[key].value.dWayTypeFromMetro == 'undefined' || this.objFilterData[key].value.dWayTypeFromMetro == ''){
								this.objFilterData[key].value.dWayTypeFromMetro == '0';
							}
							this.objGetParams['dWayTypeFromMetro'] = this.objFilterData[key].value.dWayTypeFromMetro;
						}else{
							delete this.objGetParams['dWayTypeFromMetro'];
							delete this.objGetParams['dTimeFromMetro'];
						}
					}else if(element.elementType == 'ajax-list-client'){ // if(key == 'agent_id' ||key == 'otdel_id' ||key == 'isFired'){
						if(typeof this.objFilterData.structure.value.agent_id != 'undefined' && this.objFilterData.structure.value.agent_id != ''){
							this.objGetParams['agent_id'] = this.objFilterData.structure.value.agent_id;
						} else {
							delete this.objGetParams['agent_id'];
						}
						if(typeof this.objFilterData.structure.value.otdel_id != 'undefined' && this.objFilterData.structure.value.otdel_id != ''){
							this.objGetParams['otdel_id'] = this.objFilterData.structure.value.otdel_id;
						} else {
							delete this.objGetParams['otdel_id'];
						}
						if(typeof this.objFilterData.structure.value.isFired != 'undefined' && this.objFilterData.structure.value.isFired != ''){
							this.objGetParams['isFired'] = this.objFilterData.structure.value.isFired;
						} else {
							delete this.objGetParams['isFired'];
						}
					}else{
						if(!this.$GVO.isEmpty(this.objFilterData[key].value) || this.objFilterData[key].value == '[object Object]'){
							this.objGetParams[key] = this.objFilterData[key].value;
						}else{
							delete this.objGetParams[key];
						}
					}
				}
			}
			this.bShowFilter = false;
		},
		OnFilterApply(){ // применяет параметры из фильтра и запускает запрос к АПИ
			// let objItogGetParams = this.$GVO.GetAllGet();

			//console.log('mo_module_filter OnFilterApply in filter 814',this.$GVO.unlinkObject(this.objGetParams));

			if(typeof this.$GVO.GetAllGet().dSearchType !='undefined' && this.objFilterData.dSearchType.value != this.$GVO.GetAllGet().dSearchType) {
				this.objFilterData.dSearchType.value = this.$GVO.GetAllGet().dSearchType;
			}

			

			if(typeof this.$GVO.GetAllGet().task_id !='undefined') {
				//без этого блока, при сбрасывании фильтра через тег "Сбросить всё", обнуляться эти параметры по задачам -- они важны при выполнении задачи с презентациями
				this.objGetParams.task_id = this.$GVO.GetAllGet().task_id;
				this.objGetParams.taskend_id = this.$GVO.GetAllGet().taskend_id;
				this.objGetParams.client_id = this.$GVO.GetAllGet().client_id;
				this.objGetParams.service_id = this.$GVO.GetAllGet().service_id;
			}
			
			this.ApplyFilterParams();
			this.setOptCount(this.objGetParams);
			// console.log('mo_module_filter objGetParams',this.$GVO.unlinkObject(this.objGetParams));

			if(location.search.substring(1) != this.$GVO.ObjToQueryString(this.objGetParams).substring(1)){
				this.$emit('change',this.$GVO.ObjToQueryString(this.objGetParams).substring(1));
			}
		},
		OnFilterReset(){

			this.objGetParams = {};
			
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key) && this.masExcludeParams.indexOf(key) == -1) {
					this.objFilterData[key].value = this.$GVO.SafeParseJson(JSON.stringify(this.objFilterData[key].value_default));
				}
			}
			this.OnFilterApply();
		},
		SetCats(strCat){
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key)) {
					if(typeof this.objFilterData[key].catalog != 'undefined' && this.objFilterData[key].catalog == strCat){
						this.objFilterData[key].options = this.$GVO.getCatToSelect(this.objFilterData[key].catalog);
					}
				}
			}
		},
		OnAjaxListSearch(opt){

		},
		doEnterThings() {
			this.OnFilterApply();	
			// console.log("enter was pressed on page ", location.pathname);
		},

	},
	mounted() {
		

		this.$GVO.ApiCall('cat.GET_ZIPAL_CAT',{params:['ObjectType','DealType', 'Toilet', 'Balcony', 'Renovation', 'Quarter', 'DistanceType']})
		.then((objApi) => {
			//console.log(objApi);
			if(objApi.success === true){
				for (const key in objApi.data) {
					if (Object.hasOwnProperty.call(objApi.data, key)) {
						this.$GVO.cats[key] = [];
						for (let i = 0; i < objApi.data[key].length; i++) {
							this.$GVO.cats[key].push({'id':objApi.data[key][i].value,'name':objApi.data[key][i].label});
						}
						this.SetCats(key);
					}
				}

				if((typeof this.$GVO.my_profile != 'undefined' && typeof this.$GVO.my_profile.is_boss != 'undefined') || (this.$GVO.my_profile.ObjModerator!=0)){
					if(this.$GVO.my_profile.is_boss!==0 || this.$GVO.my_profile.ObjModerator!=0){
						if(this.objFilterData.structure.rb_options.length==2){
							this.objFilterData.structure.rb_options.push({'name': '2', 'label': 'Объекты сотрудника'});
							this.objFilterData.structure.rb_options.push({'name': '3', 'label': 'Объекты отдела'});
							// this.objFilterData.structure.rb_options.push({'name': '4', 'label': 'Объекты уволенных'}); //12.04.24 Артем: если увольняется сотрудник, все его услуги перемешиваются на руководителя автоматом	
						}
					}
				}

				this.SetFilterParams();
			}
		}).catch(errorObjApi => {console.error(errorObjApi);});
		
		// var queryParams = new URLSearchParams(window.location.search);
		// history.replaceState(null, null, "?"+queryParams.toString());
		// console.log('objGetParams  line location ',window.location.search);

		this.objGetParams = this.$GVO.GetAllGet();
		//console.log('mo_module_filter objGetParams line 888 ',this.$GVO.unlinkObject(this.objGetParams));
		
		
	},
};
</script>
<style scoped>
.majorFilter-card {border: 1px solid #01b0e0;}
.majorFilter {display: flex; justify-content: space-between;}
.firstFilter-row {display: flex; flex-wrap: wrap; width: 100%;}
.filter-shown {display: block;}
.filter-hidden {display: none;}
.map-search .btn {margin-top: 0px; width: 207px; padding-left: 5px;}
.allFilters {justify-content: flex-end;}
.allFilters .btn, .applyFilter .btn {margin-top: 0px; margin-right: 15px;}
/* .id-search {max-width: 200px;} */

.ssopage >>> .el-select .el-input.is-focus .el-input__inner:focus {border: 1px solid #01B0E0;}

.map-search >>> .btn.btn-simple {border-color: #2b3553; color: rgba(255, 255, 255, 0.8); font-weight: 400;}
.white-content .map-search >>> .btn.btn-simple {color: #6062667c;}
.map-search >>> .btn.btn-simple:hover {border-color: #01b0e0; color: rgba(1, 176, 224, 0.6); font-weight: 400;}
.ssopage >>> .form-group input:hover, .input-group:hover {border: 1px solid #01b0e0;}

.ssopage >>> .el-select .el-input.is-focus .el-input__inner:hover, .el-input .el-input--large .el-input--suffix:hover {border: 1px solid #01b0e0; }
.ssopage >>> .el-input .el-input--large .el-input--suffix .is-focus {border: 1px solid #01b0e0;}
.ssopage >>> .el-select .el-input.is-focus .el-input__inner  {border: 1px solid #01b0e0;}
.ssopage >>> .el-select__input .is-large:hover > .select-primary.el-select .el-input input {border: 1px solid #01b0e0;}
/*HOVER FOR .el-icon-circle-colse*/
.ssopage >>> .el-input__suffix-inner:hover i {font-size: 20px; color: #F84E54;}

/*.ReInputSearchDropType:hover {border: 1px solid #01b0e0; border-radius: 6px;}*/
/*.ReInputSearchDropType:hover {margin-bottom: 0; border: 1px solid #01b0e0; border-radius: 6px;}*/
.moreFilter >>> .el-select .el-input .el-input__icon:hover {font-size: 24px; color: #F84E54;}

.ssopage >>>  .dropdown-menu .tim-icons {margin-top: -10px;}
.flat-corp-row, .filter-row {display: flex; flex-wrap: wrap;}

.ssopage >>> .outline-secondary {border-right: 1px solid #2b3553}
.ssopage >>> .outline-secondary:hover {border: 1px solid #01B0E0;}
.ssopage >>> .outline-secondary:focus {border-right: 1px solid #01B0E0; border-left: 1px solid #01B0E0;}
.ssopage >>> .flat-corp-row .form-control:hover, .input-group-text:focus {border: none;}
.ssopage >>> .flat-corp-row .input-group:hover {border: 1px solid #01B0E0; border-radius: 6px;}
.moModuleFilter >>> hr {border-top: 1px solid #01B0E0!important;}
.moModuleFilter >>> .el-select .el-input.is-focus .el-input__inner:focus {border: 1px solid #01B0E0;}

.sLabelText label {font-size: .9rem;}
.allFilters .btn {margin-bottom: 10px;}

.majorFilter-card >>> .el-select .el-input__inner {height: 38px;}
.moModuleFilter .ReSelectCascade {display: flex;flex-direction: row;}
.moModuleFilter >>> .ReSelectCascade .row {margin-right: 1px!important;}
.moModuleFilter >>> .id-search {padding-right: 0!important;}
.moModuleFilter >>> .ReInputSearchDrop {position: relative;}

@media (max-width: 768px) {	
	.map-search, .year-search, .type-search, .price-search, .base-search, .flat-corp-width, .id-search {margin-right: 0px !important; width: 100%;}
	.map-search .btn.btn-simple {width: 100%;}
	.majorFilter-card >>>  .overflow-overlay {max-height: 110px!important;}
}
@media (max-width: 575px) {
	.filter-row > .col-md-4, .filter-row > .col-sm-6 {padding-right: 0px;}
	.applyFilter, .allFilters, .allFilters .btn, .applyFilter .btn {width: 100%;}
	.type-search {margin-bottom: 20px !important;}
}



</style>
